import { ChangeDetectionStrategy, Component, HostBinding, NgModule, OnInit } from '@angular/core';
import { FormFieldModule } from '../../wrapper/form-field/form-field.component';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { PortalFieldTypeConfig } from '@portal/form/data-access';
import { map, Observable, startWith } from 'rxjs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { CyTestDirective } from '@portal/directive';
import { EMPTY_VALUE } from '@core/data-access';

@Component({
  selector: 'portal-form-autocomplete',
  standalone: true,
  imports: [AsyncPipe, NgForOf, NgIf, FormlyModule, ReactiveFormsModule, CyTestDirective, MatAutocompleteModule],
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutocompleteComponent extends FieldType<PortalFieldTypeConfig> implements OnInit {
  protected readonly defaultValue = EMPTY_VALUE;
  protected filter!: Observable<any>;

  @HostBinding('class') get hostClass(): string {
    return this.disabled ? 'field-value' : 'field-input-wrapper';
  }

  /**
   * Check if form or field is disabled
   * @returns boolean
   * @readonly
   */
  get disabled(): boolean {
    return !!this.options?.formState?.disabled || !!this.props?.disabled;
  }

  get type(): string {
    return this.disabled ? 'hidden' : this.props.type || 'text';
  }

  get display(): string {
    return this.props.displayWith?.(this.formControl.value) || this.formControl.value || this.defaultValue;
  }

  ngOnInit(): void {
    this.filter = this.formControl.valueChanges?.pipe(
      startWith(''),
      map(value => this.autocompleteFilter(value)),
    );
  }

  private autocompleteFilter(value: unknown): string[] {
    return typeof value === 'string'
      ? this.props?.autocomplete?.filter(state => state.toLowerCase().indexOf(value.toLowerCase()) === 0) ||
          this.props?.autocomplete?.slice() ||
          []
      : this.props?.autocomplete?.slice() || [];
  }
}

@NgModule({
  imports: [
    FormFieldModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'autocomplete',
          component: AutocompleteComponent,
          wrappers: ['form-field'],
        },
      ],
    }),
  ],
})
export class FormAutocompleteModule {}
